import axiosInstance from "./axiosInstance";

const getAllBadges = async ({pageParam = 1}) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const {data} = await axiosInstance.get(
      `/api/getAllBadges?page=${pageParam}&limit=8`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return {
      badges: data.badges,
      nextPage: pageParam + 1,
      totalPages: data.pagination.totalPages,
    };
  } catch (error) {
    throw error;
  }
};

export default getAllBadges;
